/* --- Videos --- */

const trackVideos = throttle(function () {

	// Get all the videos in the article
	const videos = [].slice.call(document.querySelectorAll('.artwork--video video'));

	videos.forEach(function(video) {

		// get their position
		const videoPosition = video.getBoundingClientRect();

		// When in reach
		if (videoPosition.top <= window.innerHeight && videoPosition.bottom > 0) {

			// Play the video
			if (!video.ended && video.readyState >= 4) {
				video.play();
				// console.log('play-' + video.id)
			}

			// Playback rate
			video.playbackRate = .5;

		} else {
			if (!video.paused) {
				video.pause();
				// console.log('pause-' + video.id)
			}
		}
	});
}, 250);
